import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../components/ui/card"
import { Users, UserCheck, MessageSquare, DollarSign, TrendingUp, Activity, ListStart } from "lucide-react"
import { checkLoginStatus, getUserData, updateUserData, logoutUser, getAllUsers } from '../../../api/authService';
import { getAllComments } from '../../../api/adminService';
import { useEffect, useState } from "react";

// const stats = [
//   {
//     title: "Total Users",
//     value: "2,847",
//     change: "+12%",
//     icon: Users,
//     description: "Active registered users",
//   },
//   {
//     title: "Admins",
//     value: "8",
//     change: "+1",
//     icon: UserCheck,
//     description: "Administrative users",
//   },
//   {
//     title: "Prayer Requests",
//     value: "156",
//     change: "+23%",
//     icon: MessageSquare,
//     description: "This month",
//   },
//   {
//     title: "Donations",
//     value: "$12,847",
//     change: "+8%",
//     icon: DollarSign,
//     description: "Total this month",
//   },
// ]

const recentActivity = [
  { action: "New user registration", user: "john.doe@tso-emails.com", time: "2 minutes ago" },
  { action: "Prayer request submitted", user: "mary.smith@tso-emails.com", time: "15 minutes ago" },
  { action: "Comment approved", user: "admin", time: "1 hour ago" },
  { action: "Slider updated", user: "admin", time: "2 hours ago" },
  { action: "New portal registration", user: "jane.wilson@tso-emails.com", time: "3 hours ago" },
]

export function DashboardSection({ allUsers, adminUsers, comments, portals, handleSectionChange }: any) {
  const thpPortal = portals.find((p: any) => p.portal === "THP");
  const stats = [
    {
      title: "Total Users",
      value: allUsers.length.toLocaleString(),
      change: "+12%", // you can dynamically calculate change if you track past value
      icon: Users,
      description: "Active registered users",
      screen: "users",
    },
    {
      title: "Admins",
      value: adminUsers.length.toString(),
      change: "+1", // optional dynamic logic
      icon: UserCheck,
      description: "Administrative users",
      screen: "users",
    },
    {
      title: "Page Comments",
      value: comments.length.toLocaleString(),
      change: "+23%",
      icon: MessageSquare,
      description: "This month",
      screen: "comments",
    },
    {
      title: "The Healing Party: Registrants",
      value: thpPortal?.data?.length?.toLocaleString() || "0",
      change: "+8%",
      icon: ListStart,
      description: "Total this month",
      screen: "registrants",
    },
  ];

  const [AdminUserString, setAdminUserString] = useState('')


  useEffect(() => {
    const array = adminUsers.map((value:any) => value.email).join(', ');
    setAdminUserString(array);
  }, [adminUsers])



  return (
    <div className="space-y-6">
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat) => (
          <Card key={stat.title} onClick={()=>{handleSectionChange(stat.screen)}} className=" cursor-pointer">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">{stat.title}</CardTitle>
              <stat.icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{stat.value}</div>
              <p className="text-xs text-muted-foreground">
                <span className="text-green-600">{stat.change}</span> {stat.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>


        <p>AdminUserString: {AdminUserString}</p>

      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Activity className="h-5 w-5" />
              Recent Activity
            </CardTitle>
            <CardDescription>Latest actions and updates</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {recentActivity.map((activity, index) => (
                <div key={index} className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium">{activity.action}</p>
                    <p className="text-xs text-muted-foreground">{activity.user}</p>
                  </div>
                  <span className="text-xs text-muted-foreground">{activity.time}</span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <TrendingUp className="h-5 w-5" />
              Quick Actions
            </CardTitle>
            <CardDescription>Common administrative tasks</CardDescription>
          </CardHeader>
          <CardContent className="space-y-2">
            <button className="w-full text-left p-2 rounded hover:bg-muted text-sm cursor-pointer" onClick={()=>handleSectionChange("comments")}>Review pending comments</button>
            <button className="w-full text-left p-2 rounded hover:bg-muted text-sm cursor-pointer" onClick={()=>handleSectionChange("email-tools")}>Send bulk email</button>
            <button className="w-full text-left p-2 rounded hover:bg-muted text-sm cursor-pointer" onClick={()=>handleSectionChange("qr-generator")}>Generate QR code</button>
            <button className="w-full text-left p-2 rounded hover:bg-muted text-sm cursor-pointer" onClick={()=>handleSectionChange("slider")}>Update homepage slider</button>
            <button className="w-full text-left p-2 rounded hover:bg-muted text-sm cursor-pointer" onClick={()=>handleSectionChange("registrants")}>Export registrant data</button>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
